import { Box } from '@mui/material';

import OperatingYearRow from '@Router/NatureOfBusiness/Components/IncomeStructure/OperatingYearRow';
import { getBuddhistYear } from '@Utils/datetime';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';
import OtherIncomeTotalForm from './OtherIncomeTotalForm';
import OperationIncomeForm from './OperationIncomeForm';
import NonOperationIncomeForm from './NonOperationIncomeForm';
import OtherIncomeAddButton from './OtherIncomeActions/OtherIncomeAddButton';
import OtherIncomeExtendedForm from './OtherIncomeExtendedForm';

const OtherIncomeForm = () => {
  const { progressData } = useProgressBar();

  const startOperatingYear =
    progressData?.report.startOperatingYear ?? getBuddhistYear();

  const operationIncome = INCOME_SUBGROUP_CATEGORY.OTHER_OPERATION_INCOME;
  const nonOperationIncome =
    INCOME_SUBGROUP_CATEGORY.OTHER_NON_OPERATION_INCOME;

  return (
    <Box mt={2}>
      <OperatingYearRow startOperatingYear={startOperatingYear} gap={1} />
      <OtherIncomeTotalForm />
      <OperationIncomeForm />
      <OtherIncomeExtendedForm subgroup={operationIncome} />
      <OtherIncomeAddButton subgroup={operationIncome} />
      <NonOperationIncomeForm />
      <OtherIncomeExtendedForm subgroup={nonOperationIncome} />
      <OtherIncomeAddButton subgroup={nonOperationIncome} />
    </Box>
  );
};

export default OtherIncomeForm;
